var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"mb-3 grey darken-4",attrs:{"rounded":""}},[_c('h2',[_vm._v("Settings")])]),_c('v-row',[_c('v-col',[_c('change-password'),_c('delete-account')],1),_c('v-col',[_c('change-email')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }